import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    // themes: {
    //   light: {
    //     primary: '#008037',
    //     secondary: '#343f4b'
    //   }
    // },
    options: {
      customProperties: true
    }
  }
})
